export default __webpack_public_path__ + "static/giant-buddha-9e642c66a1f926a89d1bcf0ee021b173.jpg";